class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    

    
    this.debouncedOnSubmit = debounce((event) => {
      
      this.onSubmitHandler(event);
      
      // document.querySelector('.shop-filters').style.display = 'none';
      gsap.to('.shop-filters', { xPercent: 0, duration: 1 });
      document.querySelector('.doneWrap').style.display = 'none';
      var trigger_sorting_html = document.querySelector(".trigger_sorting_html");
      document.querySelector(".trigger_sorting").classList.remove("active");
      gsap.to(trigger_sorting_html,{ height:0, duration: 1 });

      

      // Define the callback function for the observer
      /*function handleMutations(mutationsList, observer) {

        console.log("on submit...##");
        

            //this.filtersToggles(facetForm);
            
              // You can customize which types of mutations should trigger the function
            var activeFacetsElement = document.querySelector('.active-facets.active-facets-mobile');
            var countSortOptions = activeFacetsElement.querySelectorAll("facet-remove");
            // var nonSortOptionElements = Array.from(countSortOptions).filter(function(button) {
            //   return !button.classList.contains('sort-option');
            // });
            
            var checkedRadio = facetForm.querySelector('input[name="sort_by"]:checked');
            console.log("checkedRadio -99",checkedRadio);

            if( !activeFacetsElement.classList.contains("removeItem") )
            {
              console.log("countSortOptions",nonSortOptionElements.length)
              if (checkedRadio && checkedRadio.getAttribute("data-sort-by") == 'New to old' && countSortOptions.length ==0  ) {
                gsap.to(activeFacetsElement, { height:0, opacity:0, delay:0, duration: 1, onComplete:function(){
                  activeFacetsElement.classList.remove('facet-open');
  
                  console.log("submit 1")
                  
                } });
              }
              // else if( countSortOptions.length <= 1 ) {
              //   gsap.to(activeFacetsElement, { height:0, opacity:0, delay:0, duration: 1, onComplete:function(){
              //     activeFacetsElement.classList.remove('facet-open');
              //     console.log("submit 2")
              //   } });
              // }
              else
              {
                console.log("submit 3")
                activeFacetsElement.classList.add('facet-open');
                gsap.to(activeFacetsElement, { height:"auto", opacity:1, duration: 1});
              }
            }
            else
            {
              console.log("submit kk 3")
              activeFacetsElement.classList.remove("removeItem");
            }
            observer.disconnect();
            
      }
      const observer = new MutationObserver(handleMutations);
      const config = {
          attributes: true,   // Observe attribute changes
          childList: true,    // Observe addition or removal of child nodes
          subtree: true       // Observe the entire subtree of the target node
      };
      var observerElement = document.querySelector("#ProductGridContainer");
      observer.observe(observerElement, config);*/
      
    }, 500);

    this.debouncedOnRadioChange = debounce((event) => {
      var target = event.target;
      var audio = document.querySelector('.shatterMp3');
      audio.currentTime = 0;
      audio.play();

      // console.log("Direct load")
      
      var dataValueLabel = target.getAttribute('data-value-label');
      var dataFilterLabel = target.getAttribute('data-filter-label');
      var dataRadioName = target.getAttribute('name');


      if(dataRadioName==='filter.p.m.custom.gimme_promotion' || target.getAttribute("data-value-label")==='Gimmie' )
      {
        document.body.querySelector('main').classList.add('gimme-products');
        //cmt document.body.classList.add('color-background-2');
       
      }
      var dataGet = dataFilterLabel+': '+dataValueLabel;

      var activeFacetsElement = document.querySelector('.active-facets.active-facets-desktop');
      var facetRemoveNode = activeFacetsElement.querySelector('.active-facets__button-wrapper');

      // if (dataValueLabel==='' && window.matchMedia("(max-width: 767px)").matches) {
      //   gsap.to('.active-facets-desktop', { height:0, duration: 1 });
      // }

      //console.log("remove filters all");
      if (window.matchMedia("(max-width: 767px)").matches) {
          gsap.set(activeFacetsElement,{ height:activeFacetsElement.offsetHeight, duration:1 })
      }
      activeFacetsElement.querySelectorAll('facet-remove').forEach(( facet ) => {
        var dataFilter = facet.getAttribute('data-filter');
        if(dataFilter && dataFilter === dataFilterLabel){
           facet.remove();
        }
    })
      
  
      if (dataValueLabel) {
        console.log('facet append');
        var htmlBlock = document.createElement('div');  // Create a container for the new element
        htmlBlock.innerHTML = '<facet-remove data-filter="'+dataFilterLabel+'"><a href="javascript:;" class="active-facets__button active-facets__button--light" role="button"><span class="active-facets__button-inner button button--tertiary">'+dataValueLabel+'<svg aria-hidden="true" focusable="false" width="12" height="13" class="icon icon-close-small" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.48627 9.32917L2.82849 3.67098" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path><path d="M2.88539 9.38504L8.42932 3.61524" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path></svg><span class="visually-hidden">Remove filter</span></span></a></facet-remove>';
        var newFacetRemoveElement = htmlBlock.firstChild;
        activeFacetsElement.insertBefore(newFacetRemoveElement, facetRemoveNode);

        var filtersTopBar = document.querySelector(".active-facets.active-facets-desktop");
        var filtersBottomBar = document.querySelector(".active-facets.active-facets-mobile");
        if (window.matchMedia("(max-width: 767px)").matches) {
          var countActiveFilters = filtersTopBar.querySelectorAll(".active-facets__button");
          console.log("countActiveFilters",countActiveFilters.length);
          if( countActiveFilters.length > 0 )
          {
            gsap.to(filtersTopBar,{ height:"auto", duration:1 })
            filtersTopBar.classList.add("active_mobile_filter");
          }
          else
          {
            gsap.to(filtersTopBar,{ 
              height:0, 
              duration:1,
              onComplete:function(){
                filtersTopBar.classList.remove("active_mobile_filter");
              }
            })
          }
        }


        //var avtiveSpanElement = newFacetRemoveElement.querySelector('span');
        // if (window.matchMedia("(max-width: 767px)").matches) 
        // {
        //   var allAppendedElements = activeFacetsElement.querySelectorAll('.active-facets__button');
        //   console.log("allAppendedElements",allAppendedElements.length);
        //   if( allAppendedElements.length > 0 )
        //   {
        //     gsap.to(activeFacetsElement,{ height:"auto", duration:1 })
        //     activeFacetsElement.classList.add("active_mobile_filter");
        //   }
        //   else
        //   {
           
        //     gsap.to(activeFacetsElement,{ height:0, duration:1, onComplete:function(){
        //       activeFacetsElement.classList.remove("active_mobile_filter");
        //     } })
            
        //   }
        // }
        
      }
      else{
        var filtersTopBar = document.querySelector(".active-facets.active-facets-desktop");
        var filtersBottomBar = document.querySelector(".active-facets.active-facets-mobile");
        if (window.matchMedia("(max-width: 767px)").matches) {
          var countActiveFilters = filtersTopBar.querySelectorAll(".active-facets__button");
          console.log("countActiveFilters",countActiveFilters.length);
          if( countActiveFilters.length > 0 )
          {
            gsap.to(filtersTopBar,{ height:"auto", duration:1 })
            filtersTopBar.classList.add("active_mobile_filter");
          }
          else
          {
            gsap.to(filtersTopBar,{ 
              height:0, 
              duration:1,
              onComplete:function(){
                filtersTopBar.classList.remove("active_mobile_filter");
              }
            })
            
          }
        }
      }
      // else
      // {
      //   if(window.matchMedia("(max-width: 767px)").matches) {
      //     var allAppendedElements = activeFacetsElement.querySelectorAll('.active-facets__button');
      //     console.log("allAppendedElements",allAppendedElements.length);
      //     if( allAppendedElements.length > 0 )
      //     {
      //       gsap.to(activeFacetsElement,{ height:"auto", duration:1 })
      //       activeFacetsElement.classList.add("active_mobile_filter");
      //     }
      //     else
      //     {
      //       gsap.to(activeFacetsElement,{ height:0, duration:1, onComplete:function(){
      //         activeFacetsElement.classList.remove("active_mobile_filter");
      //       } })
      //     }
      //   }
      // }
    }, 500);
    
    const facetForm = this.querySelector('form');
    // facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    const submitBtn = facetForm.querySelector('.facets-filter-btn');
    submitBtn.addEventListener('click', this.debouncedOnSubmit.bind(this));

     const submitBtn2 = facetForm.querySelector('.facets-filter-btn2');
      submitBtn2.addEventListener('click', this.debouncedOnSubmit.bind(this));

    const facetsMain = facetForm.closest('main');

    const triggerClearFilters = facetsMain.querySelector('.trigger_clear_filters');

    
    triggerClearFilters.addEventListener('click', function(e){

      const activeFacetsMobile = facetsMain.querySelector('.active-facets-mobile');
      activeFacetsMobile.querySelector('.active-facets__button-remove').click();
          console.log("remove---");

      
     });
    

    const radioButtonFilters = facetForm.querySelector('.shop-filters');
    radioButtonFilters.querySelectorAll('input[type=radio]').forEach(( radioBtn ) => {
       radioBtn.addEventListener("change", this.debouncedOnRadioChange.bind(this));
     // radioBtn.addEventListener("change", this.onRadioChangeHandler.bind(this));
    })



    var facetRemoveNode = facetForm.querySelector('.active-facets__button-wrapper');

    var activeFacetsElement = document.querySelector('.active-facets.active-facets-mobile');

    // var countSortOptions = activeFacetsElement.querySelectorAll("facet-remove");
    // var nonSortOptionElements = Array.from(countSortOptions).filter(function(button) {
    //     return !button.classList.contains('sort-option');
    // });

    // var checkedRadio = facetForm.querySelector('input[name="sort_by"]:checked');
    // console.log("checkedRadio onload 2",checkedRadio);
    var filtersTopBar = document.querySelector(".active-facets.active-facets-desktop");
    var filtersBottomBar = document.querySelector(".active-facets.active-facets-mobile");

    console.log("Here Mobile",filtersTopBar);


      // function handleMutations(mutationsList, observer) {
        
      //         console.log("Mutations observed:", mutationsList);
              
      //         var allFilters = document.querySelectorAll(".disclosure-has-popup");
      //         if( allFilters ){
      //           allFilters.forEach((filter) => {
      //               filter.classList.remove("open-accordian");
      //               filter.classList.add("close-accordian");
      //           });
      //           observer.disconnect();
      //         }
            
      
      //     // You can disconnect the observer here if you only want to handle the first set of mutations
      //     // observer.disconnect();
      // }
  
      // const observer = new MutationObserver(handleMutations);
      // const config = {
      //     attributes: true,   // Observe attribute changes
      //     childList: true,    // Observe addition or removal of child nodes
      //     subtree: true       // Observe the entire subtree of the target node
      // };
  
      // var observerElement = document.querySelector("#ProductGridContainer");
  
      // if (observerElement) {
      //     observer.observe(observerElement, config);
      //     console.log("Observer is set on #ProductGridContainer.");
      // } else {
      //     console.error("Error: #ProductGridContainer element not found.");
      // }



    
   
    if (window.matchMedia("(max-width: 767px)").matches && filtersTopBar) {
      //MOBILE
      var countActiveFilters = filtersTopBar.querySelectorAll(".active-facets__button");
      console.log("countActiveFilters",countActiveFilters.length);
      if( countActiveFilters.length > 0 )
      {
        gsap.to(filtersTopBar,{ height:"auto", duration:1 })
        filtersTopBar.classList.add("active_mobile_filter");
      }
      else
      {
        gsap.to(filtersTopBar,{ 
          height:0, 
          duration:1,
          onComplete:function(){
            filtersTopBar.classList.remove("active_mobile_filter");
          }
        })
      }
      
      var countActiveFilters = filtersBottomBar.querySelectorAll(".active-facets__button");
      console.log("countActiveFilters",countActiveFilters.length);
      var activeSortItem = document.querySelector('.trigger_sorting_html input[name="sort_by"]:checked');
      console.log("activeSortItem",activeSortItem);
      
      if (activeSortItem && activeSortItem.getAttribute("data-sort-by") == 'New to old' && countActiveFilters.length ==0  ){
        gsap.to(filtersBottomBar, { 
          height:0, 
          opacity:0, 
          duration: 1, 
          onComplete:function(){
            filtersBottomBar.classList.remove('facet-open');
            console.log("no filter & sort selected");
          }
        });
      }
      else
      {
        console.log("have 1 filter or sort selected");
        filtersBottomBar.classList.add('facet-open');
        gsap.to(filtersBottomBar, { height:"auto", opacity:1, duration: 1});
      }
    }
    else{
      //DESKTOP
      if( filtersBottomBar ){
        var countActiveFilters = filtersBottomBar.querySelectorAll(".active-facets__button");
        console.log("countActiveFilters",countActiveFilters.length);
        var activeSortItem = document.querySelector('.trigger_sorting_html input[name="sort_by"]:checked');
        console.log("activeSortItem",activeSortItem);
        
        if (activeSortItem && activeSortItem.getAttribute("data-sort-by") == 'New to old' && countActiveFilters.length ==0  ){
          gsap.to(filtersBottomBar, { 
            height:0, 
            opacity:0, 
            duration: 1, 
            onComplete:function(){
              filtersBottomBar.classList.remove('facet-open');
              console.log("no filter & sort selected");
            }
          });
        }
        else
        {
          console.log("have 1 filter or sort selected");
          filtersBottomBar.classList.add('facet-open');
          gsap.to(filtersBottomBar, { height:"auto", opacity:1, duration: 1});
        }
      }
              
              
    }

    
    // console.log("countSortOptions",nonSortOptionElements.length)
    // if (checkedRadio.getAttribute("data-sort-by") == 'New to old' && nonSortOptionElements.length <= 1 ) {
    //   gsap.to(activeFacetsElement.querySelector(".active-facets"), { height:0, opacity:0, delay:0, duration: 1, onComplete:function(){
    //        activeFacetsElement.classList.remove('facet-open');
    //     if(activeFacetsElement.querySelector('facet-remove.sort-option')){
    //     activeFacetsElement.querySelector('facet-remove.sort-option').remove();
    //   }
    //    } });
    // }
    // else
    // {
    //   activeFacetsElement.classList.add('facet-open');
    //   gsap.to(activeFacetsElement, { height:"auto", opacity:1, duration: 1});
    // }

    

    const radioButtonSorts = facetForm.querySelectorAll('.sort_by_radio');
    radioButtonSorts.forEach(( radioBtns ) => {

      radioBtns.addEventListener('change', function(e){
        var audio = document.querySelector('.shatterMp3');
      audio.currentTime = 0;
      audio.play();
        var target = event.target;
        var dataSortBy = target.getAttribute('data-sort-by');

        var activeFacetsElement = document.querySelector('.active-facets.active-facets-mobile');
        var facetRemoveNode = activeFacetsElement.querySelector('.active-facets__button-wrapper');

        var countSortOptions = activeFacetsElement.querySelectorAll("facet-remove");

        // Filter elements to exclude those with the 'sort-option' class
        // var nonSortOptionElements = Array.from(countSortOptions).filter(function(button) {
        //     return !button.classList.contains('sort-option');
        // });

        //console.log("countSortOptions",nonSortOptionElements.length)

        //gsap.to(activeFacetsElement.querySelector('facet-remove.sort-option'),{ opacity:0, duration:0.5})
        // if (dataSortBy == 'New to old' && nonSortOptionElements.length <= 1 ) {
        //   gsap.to(activeFacetsElement, { height:0, opacity:0, delay:0, duration: 1, onComplete:function(){
        //        activeFacetsElement.classList.remove('facet-open');
        //     if(activeFacetsElement.querySelector('facet-remove.sort-option')){
        //     activeFacetsElement.querySelector('facet-remove.sort-option').remove();
        //   }
        //    } });
        // }
        // else
        // {
        //   if(activeFacetsElement.querySelector('facet-remove.sort-option')){
        //     activeFacetsElement.querySelector('facet-remove.sort-option').remove();
        //   }
        // }

          
        //  if (dataSortBy != 'New to old' ) {
        //      console.log('facet sort append');
        //     activeFacetsElement.classList.add('facet-open');
        //     var htmlBlock = document.createElement('div');  // Create a container for the new element
        //     htmlBlock.innerHTML = '<facet-remove class="sort-option" data-sort="'+target.value+'"><a href="javascript:;" class="active-facets__button active-facets__button--light" role="button"><span class="active-facets__button-inner button button--tertiary">'+dataSortBy+'<svg aria-hidden="true" focusable="false" width="12" height="13" class="icon icon-close-small" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.48627 9.32917L2.82849 3.67098" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path><path d="M2.88539 9.38504L8.42932 3.61524" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path></svg><span class="visually-hidden">Remove filter</span> </span></a></facet-remove>';
        //     var newFacetRemoveElement = htmlBlock.firstChild;
        //     activeFacetsElement.insertBefore(newFacetRemoveElement, facetRemoveNode);
  
        //      console.log('1');
        //     // activeFacetsElement.classList.add('facet-open');
        //      gsap.to(activeFacetsElement, { height:"auto", opacity:1, duration: 1, onComplete:function(){
        //      } });
        // }  
      
       });

     
    })

    

    
    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
    
  }

  static setListeners() {
    
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };

     
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
 
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    if(sections){
      
    
    //const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll('.facets-container .loading__spinner, facet-filters-form .loading__spinner');
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    if(document.getElementById('ProductGridContainer')){
      document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    }
    
    // if (countContainer) {
    //   countContainer.classList.add('loading');
    // }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
      }

    
    
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        //FacetFiltersForm.renderProductCount(html);
        
        facetFilters();

        console.log("triggerAnimation")
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    //FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });

    console.log("GRID CONTAINER");
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll('.facets-container .loading__spinner, facet-filters-form .loading__spinner');
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newElementSelector = document
          .getElementById(closestJSFilterID)
          .classList.contains('mobile-facets__details')
          ? `#${closestJSFilterID} .mobile-facets__close-button`
          : `#${closestJSFilterID} .facets__summary`;
        const newElementToActivate = document.querySelector(newElementSelector);
        if (newElementToActivate) newElementToActivate.focus();
      }
    }


     const radioButtonFiltersNew = document.querySelector('.shop-filters');
    radioButtonFiltersNew.querySelectorAll('input[type=radio]').forEach(( radioBtn ) => {
       radioBtn.addEventListener("change", FacetFiltersForm.onRadioChangeHandler.bind(this));
    })

    const radioButtonSortsNew = document.querySelectorAll('.sort_by_radio');
    radioButtonSortsNew.forEach(( radioBt ) => {

      radioBt.addEventListener('change', function(e){
        var rTarget = e.target;
        var audio = document.querySelector('.shatterMp3');
        audio.currentTime = 0;
        audio.play();
        console.log('facet sort append');
        var dataSortBy = rTarget.getAttribute('data-sort-by');
        var activeFacetsElement = document.querySelector('.active-facets.active-facets-mobile');
        var facetRemoveNode = activeFacetsElement.querySelector('.active-facets__button-wrapper');
        
        var countSortOptions = activeFacetsElement.querySelectorAll("facet-remove");

        // Filter elements to exclude those with the 'sort-option' class
        // var nonSortOptionElements = Array.from(countSortOptions).filter(function(button) {
        //     return !button.classList.contains('sort-option');
        // });

        //console.log("countSortOptions",nonSortOptionElements.length)

        //gsap.to(activeFacetsElement.querySelector('facet-remove.sort-option'),{ opacity:0, duration:0.5})
        // if (dataSortBy == 'New to old' && nonSortOptionElements.length <= 1 ) {
        //   gsap.to(activeFacetsElement, { height:0, opacity:0, delay:0, duration: 1, onComplete:function(){
        //       activeFacetsElement.classList.remove('facet-open');
        //       if(activeFacetsElement.querySelector('facet-remove.sort-option')){
        //         activeFacetsElement.querySelector('facet-remove.sort-option').remove();
        //       }
        //    } });
        // }
        // else{
        //   if(activeFacetsElement.querySelector('facet-remove.sort-option')){
        //     activeFacetsElement.querySelector('facet-remove.sort-option').remove();
        //   }
          
        // }
        
        // if (dataSortBy != 'New to old') {
        //   activeFacetsElement.classList.add('facet-open');
        //   var htmlBlock = document.createElement('div');  // Create a container for the new element
        //   htmlBlock.innerHTML = '<facet-remove class="sort-option" data-sort="'+rTarget.value+'"><a href="javascript:;" class="active-facets__button active-facets__button--light" role="button"><span class="active-facets__button-inner button button--tertiary">'+dataSortBy+'<svg aria-hidden="true" focusable="false" width="12" height="13" class="icon icon-close-small" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.48627 9.32917L2.82849 3.67098" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path><path d="M2.88539 9.38504L8.42932 3.61524" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path></svg><span class="visually-hidden">Remove filter</span> </span></a></facet-remove>';
        //   var newFacetRemoveElement = htmlBlock.firstChild;
        //   activeFacetsElement.insertBefore(newFacetRemoveElement, facetRemoveNode);

        //   gsap.to(activeFacetsElement, { height:"auto", opacity:1, delay:0.2, duration: 1, onComplete:function(){
        //   } });
        // }  
      });

      
      // radioBt.addEventListener("change", function (e) {
         
      //  document.querySelector('.facets-filter-btn').click();
        
     // });
     
    })

    console.log("filter rendered");
    var filtersTopBar = document.querySelector(".active-facets.active-facets-desktop");
    var filtersBottomBar = document.querySelector(".active-facets.active-facets-mobile");
    if (window.matchMedia("(max-width: 767px)").matches) {
      //MOBILE


      var countActiveFilters = filtersTopBar.querySelectorAll(".active-facets__button");
      console.log("countActiveFilters",countActiveFilters.length);
      if( countActiveFilters.length > 0 )
      {
        gsap.to(filtersTopBar,{ height:"auto", duration:1 })
        filtersTopBar.classList.add("active_mobile_filter");
      }
      else
      {
        gsap.to(filtersTopBar,{ 
          height:0, 
          duration:1,
          onComplete:function(){
            filtersTopBar.classList.remove("active_mobile_filter");
          }
        })
      }
      
      var countActiveFilters = filtersBottomBar.querySelectorAll(".active-facets__button");
      console.log("countActiveFilters",countActiveFilters.length);
      var activeSortItem = document.querySelector('.trigger_sorting_html input[name="sort_by"]:checked');
      console.log("activeSortItem",activeSortItem);
      
      if (activeSortItem && activeSortItem.getAttribute("data-sort-by") == 'New to old' && countActiveFilters.length ==0  ){
        gsap.to(filtersBottomBar, { 
          height:0, 
          opacity:0, 
          duration: 1, 
          onComplete:function(){
            filtersBottomBar.classList.remove('facet-open');
            console.log("no filter & sort selected");
          }
        });
      }
      else
      {
        console.log("have 1 filter or sort selected");
        filtersBottomBar.classList.add('facet-open');
        gsap.to(filtersBottomBar, { height:"auto", opacity:1, duration: 1});
      }
    }
    else{
      //DESKTOP
      var countActiveFilters = filtersBottomBar.querySelectorAll(".active-facets__button");
      console.log("countActiveFilters",countActiveFilters.length);
      var activeSortItem = document.querySelector('.trigger_sorting_html input[name="sort_by"]:checked');
      console.log("activeSortItem",activeSortItem);
      
      if (activeSortItem && activeSortItem.getAttribute("data-sort-by") == 'New to old' && countActiveFilters.length ==0  ){
        gsap.to(filtersBottomBar, { 
          height:0, 
          opacity:0, 
          duration: 1, 
          onComplete:function(){
            filtersBottomBar.classList.remove('facet-open');
            console.log("no filter & sort selected");
          }
        });
      }
      else
      {
        console.log("have 1 filter or sort selected");
        filtersBottomBar.classList.add('facet-open');
        gsap.to(filtersBottomBar, { height:"auto", opacity:1, duration: 1});
      }
              
              
    }
    
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);

  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    //document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    if(document.querySelector('#product-grid')){
     var productGridItems = document.querySelector('#product-grid');
      return [
      {
        section: productGridItems.dataset.id,
      },
    ];
      
    } else {
      return;
    }
    
  }

   static onRadioChangeHandler(event) {
      console.log("DOM PAGE TRNAITIOn");
      var audio = document.querySelector('.shatterMp3');
      audio.currentTime = 0;
      audio.play();
     var target = event.target;
      var dataValueLabel = target.getAttribute('data-value-label');
      var dataFilterLabel = target.getAttribute('data-filter-label');

       var dataRadioName = target.getAttribute('name');
  
        if(dataRadioName==='filter.p.m.custom.gimme_promotion' || target.getAttribute("data-value-label")==='Gimmie')
        {
          document.body.querySelector('main').classList.add('gimme-products');
          //cmt document.body.classList.add('color-background-2');
        }
       
      var dataGet = dataFilterLabel+': '+dataValueLabel;


     console.log('facet append kk');
     
      var activeFacetsElement = document.querySelector('.active-facets.active-facets-desktop');
      var facetRemoveNode = activeFacetsElement.querySelector('.active-facets__button-wrapper');
      // if (dataValueLabel==='' && window.matchMedia("(max-width: 767px)").matches) 
      // {
      //   gsap.to('.active-facets-desktop', { height:0, duration: 1 });
      // }
      if (window.matchMedia("(max-width: 767px)").matches) {
          gsap.set(activeFacetsElement,{ height:activeFacetsElement.offsetHeight, duration:1 })
      }
      activeFacetsElement.querySelectorAll('facet-remove').forEach(( facet ) => {
        var dataFilter = facet.getAttribute('data-filter');
        if(dataFilter && dataFilter === dataFilterLabel){
           facet.remove();
        }
    })
     console.log("dataValueLabel",dataValueLabel);

     if (dataValueLabel) {
        console.log('facet append');
        var htmlBlock = document.createElement('div');  // Create a container for the new element
        htmlBlock.innerHTML = '<facet-remove data-filter="'+dataFilterLabel+'"><a href="javascript:;" class="active-facets__button active-facets__button--light" role="button"><span class="active-facets__button-inner button button--tertiary">'+dataValueLabel+'<svg aria-hidden="true" focusable="false" width="12" height="13" class="icon icon-close-small" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.48627 9.32917L2.82849 3.67098" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path><path d="M2.88539 9.38504L8.42932 3.61524" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path></svg><span class="visually-hidden">Remove filter</span></span></a></facet-remove>';
        var newFacetRemoveElement = htmlBlock.firstChild;

        activeFacetsElement.insertBefore(newFacetRemoveElement, facetRemoveNode);



         var filtersTopBar = document.querySelector(".active-facets.active-facets-desktop");
        var filtersBottomBar = document.querySelector(".active-facets.active-facets-mobile");
        if (window.matchMedia("(max-width: 767px)").matches) {
          var countActiveFilters = filtersTopBar.querySelectorAll(".active-facets__button");
          console.log("countActiveFilters",countActiveFilters.length);
          if( countActiveFilters.length > 0 )
          {
            gsap.to(filtersTopBar,{ height:"auto", duration:1 })
            filtersTopBar.classList.add("active_mobile_filter");
          }
          else
          {
            gsap.to(filtersTopBar,{ 
              height:0, 
              duration:1,
              onComplete:function(){
                filtersTopBar.classList.remove("active_mobile_filter");
              }
            })
          }
        }


        //var avtiveSpanElement = newFacetRemoveElement.querySelector('span');


       
        // if (window.matchMedia("(max-width: 767px)").matches) 
        // {
        //   var allAppendedElements = activeFacetsElement.querySelectorAll('.active-facets__button');
        //   console.log("allAppendedElements",allAppendedElements.length);
        //   if( allAppendedElements.length > 0 )
        //   {
        //     gsap.to(activeFacetsElement,{ height:"auto", duration:1 })
        //     activeFacetsElement.classList.add("active_mobile_filter");
        //   }
        //   else
        //   {
           
        //     gsap.to(activeFacetsElement,{ height:0, duration:1, onComplete:function(){
        //       activeFacetsElement.classList.remove("active_mobile_filter");
        //     } })
            
        //   }
        // }
        
      }
      else
      {
        var filtersTopBar = document.querySelector(".active-facets.active-facets-desktop");
        var filtersBottomBar = document.querySelector(".active-facets.active-facets-mobile");
        if (window.matchMedia("(max-width: 767px)").matches) {
          var countActiveFilters = filtersTopBar.querySelectorAll(".active-facets__button");
          console.log("countActiveFilters",countActiveFilters.length);
          if( countActiveFilters.length > 0 )
          {
            gsap.to(filtersTopBar,{ height:"auto", duration:1 })
            filtersTopBar.classList.add("active_mobile_filter");
          }
          else
          {
            gsap.to(filtersTopBar,{ 
              height:0, 
              duration:1,
              onComplete:function(){
                filtersTopBar.classList.remove("active_mobile_filter");
              }
            })
          }
        }
        // if(window.matchMedia("(max-width: 767px)").matches) {
        //   var allAppendedElements = activeFacetsElement.querySelectorAll('.active-facets__button');
        //   console.log("allAppendedElements",allAppendedElements.length);
        //   if( allAppendedElements.length > 0 )
        //   {
        //     gsap.to(activeFacetsElement,{ height:"auto", duration:1 })
        //     activeFacetsElement.classList.add("active_mobile_filter");
        //   }
        //   else
        //   {
        //     gsap.to(activeFacetsElement,{ height:0, duration:1, onComplete:function(){
        //       activeFacetsElement.classList.remove("active_mobile_filter");
        //     } })
        //   }
        // }
      }

     
    }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
    
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }

    facetFilters();
    
  }


  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  onActiveFilterClick(event) {
   
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();


class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();


     var priceRangeSlider = this.querySelector(".price-range-slider");
      priceRangeSlider.querySelectorAll("input").forEach(( slider ) => {
       slider.addEventListener("input", this.onRangeSliderChangeUpdateValues.bind(this));
      })
    
   // var priceSlider = document.querySelector(".price-range-slider");
     var priceSlider = priceRangeSlider;
    var shopFiltersElement = document.querySelector(".shop-filters");
    var rangeAmount = document.querySelector(".range-amount");
    var minPriceSlider = document.querySelector('#min-price');
    var maxPriceSlider = document.querySelector('#max-price');
    var minPriceDisplay = document.getElementById("min-price-display");
    var maxPriceDisplay = document.getElementById("max-price-display");
    if(priceSlider.getAttribute('data-filtermax'))
    {
       var filterMax = parseInt(priceSlider.getAttribute('data-filtermax'));
    } else {
       var filterMax = 0;
    }
   
    var threshold = 10;

    
     priceSlider.addEventListener("click", function(event) {
      var rect = priceSlider.getBoundingClientRect();
      var clickPosition = ((event.clientX - rect.left) / rect.width) * filterMax;
  
      var minPrice1 = parseInt(minPriceSlider.value);
      var maxPrice1 = parseInt(maxPriceSlider.value);
      var distanceToMin = Math.abs(clickPosition - minPrice1);
      var distanceToMax = Math.abs(clickPosition - maxPrice1);

      if (distanceToMin < distanceToMax) {
        minPriceSlider.value = clickPosition < maxPrice1 - threshold ? clickPosition : maxPrice - threshold;
      } else {
        maxPriceSlider.value = clickPosition > minPrice1 + threshold ? clickPosition : minPrice + threshold;
      }


       let minPrice = parseInt(minPriceSlider.value);
      let maxPrice = parseInt(maxPriceSlider.value);

      if (maxPrice - minPrice < threshold) {
          minPrice = maxPrice - threshold;
          if (minPrice < 0) {
              minPrice = 0; // Ensure minPrice does not go below 0
          }
          minPriceSlider.value = minPrice; // Update the input value
      }

       shopFiltersElement.querySelector('[name="filter.v.price.gte"]').value = minPrice;
        shopFiltersElement.querySelector('[name="filter.v.price.lte"]').value = maxPrice;

        var lower_bound_progress = (minPrice / filterMax) * 100.0;
        var higher_bound_progress = (maxPrice / filterMax) * 100.0;

       // GSAP animations for the display values
        gsap.to(minPriceDisplay, { textContent: minPrice, roundProps: "textContent", duration: 0.5 });
        gsap.to(maxPriceDisplay, { textContent: maxPrice, roundProps: "textContent", duration: 0.5 });

  // GSAP animations for the slider handle positions
        gsap.to(priceSlider, {
            '--range-min': `${lower_bound_progress}%`,
            '--range-max': `${higher_bound_progress}%`,
            duration: 0.5
        });

       // Update the range amount display with GSAP
        gsap.to(rangeAmount, {
            textContent: `$${minPrice} - $${maxPrice}`,
            duration: 0.5,
            onUpdate: function() {
                rangeAmount.innerHTML = `$${minPrice} - $${maxPrice}`;
            }
        });
       
       

       
  });


    
  
  }


  
  onRangeSliderChangeUpdateValues(event) {
     var priceSlider = document.querySelector(".price-range-slider");
    var shopFiltersElement = document.querySelector(".shop-filters");
    var rangeAmount = document.querySelector(".range-amount");
    var minPriceSlider = document.querySelector('#min-price');
    var maxPriceSlider = document.querySelector('#max-price');
    var minPriceDisplay = document.getElementById("min-price-display");
    var maxPriceDisplay = document.getElementById("max-price-display");
    var filterMax = parseInt(priceSlider.getAttribute('data-filtermax'));
    var threshold = 10;

    let minPrice = parseInt(minPriceSlider.value);
        let maxPrice = parseInt(maxPriceSlider.value);

     if (maxPrice - minPrice < threshold) {
      if (minPriceSlider === document.activeElement) {
        minPrice = maxPrice - threshold;
        minPriceSlider.value = minPrice;
      } else if (maxPriceSlider === document.activeElement) {
        maxPrice = minPrice + threshold;
        maxPriceSlider.value = maxPrice;
      }
    }
    
/*
        if (maxPrice - minPrice < threshold) {
            minPrice = maxPrice - threshold;
            if (minPrice < 0) {
                minPrice = 0; // Ensure minPrice does not go below 0
            }
            minPriceSlider.value = minPrice; // Update the input value
        }
*/
        shopFiltersElement.querySelector('[name="filter.v.price.gte"]').value = minPrice;
        shopFiltersElement.querySelector('[name="filter.v.price.lte"]').value = maxPrice;

        var lower_bound_progress = (minPrice / filterMax) * 100.0;
        var higher_bound_progress = (maxPrice / filterMax) * 100.0;

        // GSAP animations for the display values
        gsap.to(minPriceDisplay, { textContent: minPrice, roundProps: "textContent", duration: 0.5 });
        gsap.to(maxPriceDisplay, { textContent: maxPrice, roundProps: "textContent", duration: 0.5 });

        // GSAP animations for the slider handle positions
        gsap.to(priceSlider, {
            '--range-min': `${lower_bound_progress}%`,
            '--range-max': `${higher_bound_progress}%`,
            duration: 0.5
        });

        // Update the range amount display with GSAP
        gsap.to(rangeAmount, {
            textContent: `$${minPrice} - $${maxPrice}`,
            duration: 0.5,
            onUpdate: function() {
                rangeAmount.innerHTML = `$${minPrice} - $${maxPrice}`;
            }
        });
    

    
  }

  
  onRangeSliderChange(event) {
    var priceSlider = document.querySelector(".price-range-slider");
    var shopFiltersElement = document.querySelector(".shop-filters");
    var rangeAmount = document.querySelector(".range-amount");
    var minPrice = priceSlider.querySelector('#min-price').value;
    var maxPrice = priceSlider.querySelector('#max-price').value;
    var filterMax = parseInt(priceSlider.getAttribute('data-filterMax'));
    var threshold = 10; 


     if (maxPrice - minPrice < threshold) {
        minPrice = maxPrice - threshold;
        if (minPrice < 0) {
            minPrice = 0; // Ensure minPrice does not go below 0
        }
        document.querySelector('#min-price').value = minPrice; // Update the input value
    }

    
    shopFiltersElement.querySelector('[name="filter.v.price.gte"]').value = minPrice;
    shopFiltersElement.querySelector('[name="filter.v.price.lte"]').value = maxPrice;
    var lower_bound_progress = (minPrice/filterMax) * 100.0 ;
    var higher_bound_progress = (maxPrice/filterMax) * 100.0 ;


    rangeAmount.innerHTML = '$'+minPrice +' - $'+ maxPrice;
    priceSlider.style.setProperty('--range-min', `${lower_bound_progress}%`);
    priceSlider.style.setProperty('--range-max', `${higher_bound_progress}%`);
  //  priceSlider.setAttribute('data-filterMax', maxPrice);
    
  }

  
  
  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

// class InputRadioElements extends HTMLElement {
//   constructor() {
//     super();
//     console.log('this', this)
//   }
  
// }
// customElements.define('input-radio-element', InputRadioElements);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    if(this.querySelector('.active-facets__button')){
     
      const facetLink = this.querySelector('.active-facets__button');
      facetLink.setAttribute('role', 'button');
     // facetLink.addEventListener('click', this.closeFilter.bind(this));
       facetLink.addEventListener('click', this.closeClearSelected.bind(this));
      // facetLink.addEventListener('keyup', (event) => {
      //   event.preventDefault();
      //   if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
      // });
    }

    if(this.querySelector('.active-facets__button-remove')){
      
      const facetLinkc = this.querySelector('.active-facets__button-remove');
      facetLinkc.addEventListener('click', this.closeFilter.bind(this));
      facetLinkc.addEventListener('keyup', (event) => {
        event.preventDefault();
        if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
      });
      
    }
      
  }


  filtersToggles(form){
   // console.log('filtersToggles', form);

    /*var trigger_filters = form.querySelector(".trigger_filters");
    var shopFiltersElement = form.querySelector(".shop-filters");

    var trigger_filter_close = form.querySelector(".trigger_filter_close");

    if (window.matchMedia("(max-width: 767px)").matches) {
      var allFilters = form.querySelectorAll(".disclosure-has-popup");
       
      allFilters.forEach(( filter ) => {
        filter.classList.remove("open-accordian");
        filter.classList.add("close-accordian");
        var filterHeading = filter.querySelector("summary.facets__summary");
        filterHeading.addEventListener("click", function(e){
          if( filter.classList.contains("close-accordian") )
          {
            filter.classList.remove("close-accordian");
            filter.classList.add("open-accordian");
          } else{
            filter.classList.add("close-accordian");
            filter.classList.remove("open-accordian");
          }
          
        })
      })
    }  */

  }
  
  closeFilter(event) {
    console.log('closeFilter');
    
     

     // gsap.to(document.querySelector('.active-facets-mobile'), { height:0, opacity:0, delay:0, duration: 1, onComplete:function(){
     //         document.querySelector('.active-facets-mobile').classList.remove('facet-open');
       
     //   } });

    
    event.preventDefault();
    
    document.body.querySelector('main').classList.remove('gimme-products');
    //cmt document.body.classList.remove('color-background-2');
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    
   // console.log('2');
   
     if (window.matchMedia("(max-width: 767px)").matches) {
       // var avtiveSpanElement = form.querySelector('.active-facets.active-facets-desktop').querySelectorAll('span');
       // avtiveSpanElement.forEach(( act ) => {
       //   gsap.to(act, { yPercent:-117, duration: 1 });
       // })
       //gsap.to('.active-facets-desktop', { height:"0", delay:1, duration: 1 });
     }
    
    var activeFacetsElement = document.querySelector('.active-facets.active-facets-mobile');
    gsap.set(activeFacetsElement,{ height: activeFacetsElement.offsetHeight });

     var activeFacetsElementMObile = document.querySelector('.active-facets-horizontal-filters .active-facets-desktop ');
    gsap.set(activeFacetsElementMObile,{ height: activeFacetsElementMObile.offsetHeight });
    // gsap.to(activeFacetsElementMObile, { height:0, duration: 1, onComplete:function(){
    //   activeFacetsElementMObile.classList.remove('active_mobile_filter');
    // }})
    
    // gsap.to(activeFacetsElement, { height:0, opacity:0, delay:0, duration: 1, onComplete:function(){
    //     activeFacetsElement.classList.remove('facet-open');
    //     form.onActiveFilterClick(event);
    //   } 
    // });
    
    form.onActiveFilterClick(event);
    
    setTimeout(() => {
       this.filtersToggles(form);
    },1000);
  }
    
  closeClearSelected(event) {
     console.log('closeClearSelected');
    event.preventDefault();
    
    var thisDataFilter = this.closest('facet-remove').getAttribute('data-filter');
    var thisDataSort = this.closest('facet-remove').getAttribute('data-sort');
    
    
    // if(this.closest('.shop-filters')){
    //   var filteredRadios = this.closest('.shop-filters').querySelectorAll('input[type="radio"][data-filter-label="'+thisDataFilter+'"]');
    //   filteredRadios.forEach((fRadio) => {
    //       fRadio.checked = false;
    //   });
    // }

    if(document.querySelector('.shop-filters')){
      var filteredRadios = document.querySelector('.shop-filters').querySelectorAll('input[type="radio"][data-filter-label="'+thisDataFilter+'"]');
      filteredRadios.forEach((fRadio) => {
          fRadio.checked = false;
      });
    }

    if(this.closest('.active-facets-mobile')){
      
      if(this.closest('.facets-container'))
      {
       const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
        
        

       //  gsap.to(this.closest('.active-facets-mobile'), { height:0, opacity:0, delay:0, duration: 1, onComplete:function(){
       //       this.closest('.active-facets-mobile').classList.remove('facet-open');
       // } });

        
        if(thisDataSort){
          var sortRadios = this.closest('.facets-container').querySelectorAll('.sort_by_radio');
          sortRadios.forEach((sRadio) => {
              sRadio.checked = false;
          });
          }
       
        
        
        form.querySelector('.facets-filter-btn').click();
         
        //this.closest('.facets-container').querySelector('form').click();
      }

      
    }
    if(thisDataFilter === 'Gimme'){
      document.body.querySelector('main').classList.remove('gimme-products');
       //cmt document.body.classList.remove('color-background-2');
    }


    if (window.matchMedia("(max-width: 767px)").matches) {
      //var avtiveSpanElement = this.closest('facet-remove').querySelector('span');
      
      //var activeButtons = this.closest('.active-facets.active-facets-desktop').querySelectorAll('.active-facets__button');

      // if(activeButtons.length === 1){
      //   // gsap.to(avtiveSpanElement, { yPercent:-117, duration: 1 });
      //    gsap.to('.active-facets-desktop', { height:"0", delay:1, duration: 1 });
      // } 
      

      console.log('facet remove mobile');
      var thieElemt = this;

      var filtersTopBar = document.querySelector(".active-facets.active-facets-desktop");
      var filtersBottomBar = document.querySelector(".active-facets.active-facets-mobile");
      console.log("filtersTopBar.offsetHeight",filtersTopBar.offsetHeight);
      gsap.set(filtersTopBar,{ height:filtersTopBar.offsetHeight })

      console.log("filtersBottomBar.offsetHeight",filtersBottomBar.offsetHeight);
      gsap.set(filtersBottomBar,{ height:filtersBottomBar.offsetHeight });

      var countActiveFilters = filtersTopBar.querySelectorAll(".active-facets__button");
      console.log("countActiveFilters",countActiveFilters.length);
      if( countActiveFilters.length > 1 )
      {
        gsap.to(filtersTopBar,{ 
          height:"auto", 
          duration:1,
          onComplete:function(){
            thieElemt.remove();
          }
        })
        filtersTopBar.classList.add("active_mobile_filter");
      }
      else
      {
        gsap.to(filtersTopBar,{ 
          height:0, 
          duration:1,
          onComplete:function(){
            filtersTopBar.classList.remove("active_mobile_filter");
            thieElemt.remove();

          }
        })
      }


      
      // if( topElementMobile.querySelectorAll(".active-facets__button").length <= 1 ){
      //   gsap.to(topElementMobile, { height:0, duration: 1, onComplete:function(){
      //     topElementMobile.classList.remove('active_mobile_filter');
      //     thieElemt.remove();
      //   }
      //   })
      // }
      
      
       
      var activeFacetsElement = document.querySelector('.active-facets.active-facets-mobile');

      
      
      // var countSortOptions = activeFacetsElement.querySelectorAll("facet-remove");
      // var nonSortOptionElements = Array.from(countSortOptions).filter(function(button) {
      //   return !button.classList.contains('sort-option');
      // });
      //activeFacetsElement.classList.add("removeItem");
      
      
      var checkedRadio = document.querySelector('input[name="sort_by"]:checked');
      console.log("checkedRadio onload",checkedRadio);
      
      // console.log("countSortOptions",nonSortOptionElements.length)
      // if (checkedRadio && checkedRadio.getAttribute("data-sort-by") == 'New to old' && nonSortOptionElements.length <= 1 ) {
      //   gsap.to(activeFacetsElement, { height:0, opacity:0, delay:0, duration: 1, onComplete:function(){
      //     activeFacetsElement.classList.remove('facet-open');
      //     thieElemt.remove();
      //     console.log("in 1")
      //     //activeFacetsElement.classList.add("removeItem");
          
      //   } });
      // }
      // else if( countSortOptions.length <= 2 ) {
      //         gsap.to(activeFacetsElement, { height:0, opacity:0, delay:0, duration: 1, onComplete:function(){
      //           activeFacetsElement.classList.remove('facet-open');
      //           //activeFacetsElement.classList.add("removeItem");
      //           thieElemt.remove();
      //           console.log("Inn 2")
      //         } });
      //       }
      
      // else
      // {
      //   thieElemt.remove();
      //   console.log("in 3")
        
      //   activeFacetsElement.classList.add('facet-open');
      //   gsap.to(activeFacetsElement, { height:"auto", opacity:1, duration: 1});
      // }
      
      // setTimeout(() => {
      //   this.remove();
      // }, 1000);
    } else {
      console.log("dektop remove this");


      var thieElemt = this;
      var filtersTopBar = document.querySelector(".active-facets.active-facets-desktop");
      var filtersBottomBar = document.querySelector(".active-facets.active-facets-mobile");
      console.log("filtersTopBar.offsetHeight",filtersTopBar.offsetHeight);
      gsap.set(filtersTopBar,{ height:filtersTopBar.offsetHeight })

      console.log("filtersBottomBar.offsetHeight",filtersBottomBar.offsetHeight);
      gsap.set(filtersBottomBar,{ height:filtersBottomBar.offsetHeight })

      thieElemt.remove();
      //var activeFacetsElement = document.querySelector('.active-facets.active-facets-mobile');
      // var countSortOptions = activeFacetsElement.querySelectorAll("facet-remove");
      // var nonSortOptionElements = Array.from(countSortOptions).filter(function(button) {
      //   return !button.classList.contains('sort-option');
      // });
      // activeFacetsElement.classList.add("removeItem");
      
      
      // var checkedRadio = document.querySelector('input[name="sort_by"]:checked');
      // console.log("checkedRadio onload 1",checkedRadio);
      
      // console.log("countSortOptions",nonSortOptionElements.length)
      // if (checkedRadio && checkedRadio.getAttribute("data-sort-by") == 'New to old' && nonSortOptionElements.length <= 1 ) {
      //   gsap.to(activeFacetsElement, { height:0, opacity:0, delay:0, duration: 1, onComplete:function(){
      //     activeFacetsElement.classList.remove('facet-open');
      //     thieElemt.remove();
      //     console.log("in 1")
      //     //activeFacetsElement.classList.add("removeItem");
          
      //   } });
      // }
      // else if( countSortOptions.length <= 2 ) {
      //         gsap.to(activeFacetsElement, { height:0, opacity:0, delay:0, duration: 1, onComplete:function(){
      //           activeFacetsElement.classList.remove('facet-open');
      //           //activeFacetsElement.classList.add("removeItem");
      //           thieElemt.remove();
      //           console.log("Inn 2")
      //         } });
      //       }
      
      // else
      // {
      //   thieElemt.remove();
      //   console.log("in 3")
        
      //   activeFacetsElement.classList.add('facet-open');
      //   gsap.to(activeFacetsElement, { height:"auto", opacity:1, duration: 1});
      // }
    }
    
     
   
  }
}

customElements.define('facet-remove', FacetRemove);
